<template>
  <li :class="{ 'load-cancelled': decorated.status_text === 'Cancelled' }">
    <p class="load-reference">
      <router-link :to="{ name: 'loads.show', params: { id: load.id }}">{{ load.reference_number }}</router-link>
      - {{ decorated.size }}
    </p>
    <span class="status text-primary" :class="decorated.status_class">{{ decorated.status_text }}</span>
    <p class="text-muted">{{ decorated.registration }} - {{ decorated.company }}</p>
    <p class="text-muted">Loading {{ decorated.loading_date }} at {{ decorated.loading_time }}</p>
  </li>
</template>
<script>
import { loadHelpers } from 'mixins/loads'
export default {
  mixins: [loadHelpers],

  props: [
    'load'
  ]
}
</script>



// WEBPACK FOOTER //
// JobLoad.vue?c5c4733e